import {hourOfAiHex} from '../colors/palette';

export const COLORS = {
  black: hourOfAiHex('black'),
  white: hourOfAiHex('white'),
  brandPrimary: hourOfAiHex('purpleDark'),
  brandSecondary: hourOfAiHex('pinkPrimary'),
  brandTertiary: hourOfAiHex('bluePrimary'),
  backgroundPrimary: hourOfAiHex('white'),
  grey200: hourOfAiHex('blueLight'),
};
